/* vestidogs-v11 */


document.addEventListener('DOMContentLoaded',function(){
  var root=document.getElementById('vdw-root');
  if(!root)return;

  document.getElementById('vdw-toggle').addEventListener('click',function(){
    var o=root.classList.toggle('is-open');
    this.setAttribute('aria-expanded',o);
  });

  var sizes=[
    {t:'XS',c:[21,23],p:[30,34],l:[20,24],kg:[1.5,3],color:'#ffd100',text:'#111'},
    {t:'S',c:[24,26],p:[35,39],l:[25,29],kg:[3,6],color:'#003087',text:'#fff'},
    {t:'M',c:[27,29],p:[40,44],l:[30,34],kg:[6,10],color:'#ce1126',text:'#fff'},
    {t:'L',c:[30,32],p:[45,49],l:[35,39],kg:[10,15],color:'#ffd100',text:'#111'},
    {t:'XL',c:[33,35],p:[50,54],l:[40,44],kg:[15,22],color:'#111',text:'#fff'},
    {t:'3XL',c:[39,44],p:[60,67],l:[50,54],kg:[22,30],color:'#ffd100',text:'#111'},
    {t:'4XL',c:[45,49],p:[68,75],l:[55,59],kg:[25,35],color:'#003087',text:'#fff'},
    {t:'5XL',c:[50,54],p:[76,83],l:[60,64],kg:[27,35],color:'#ce1126',text:'#fff'}
  ];

  var F={
    p:document.getElementById('vdw-chest'),
    c:document.getElementById('vdw-neck'),
    l:document.getElementById('vdw-back'),
    kg:document.getElementById('vdw-weight')
  };
  if(!F.p)return;

  var live=document.getElementById('vdw-live'),
      result=document.getElementById('vdw-result'),
      fuera=document.getElementById('vdw-fuera'),
      badge=document.getElementById('vdw-badge'),
      title=document.getElementById('vdw-title'),
      detail=document.getElementById('vdw-detail'),
      conf=document.getElementById('vdw-confidence'),
      fit=document.getElementById('vdw-fit'),
      warn=document.getElementById('vdw-warning'),
      wa=document.getElementById('vdw-wa'),
      copyBtn=document.getElementById('vdw-copy'),
      copyState=document.getElementById('vdw-copy-state'),
      last='';

  function getVal(id){
    var el=document.getElementById(id);
    return el?parseFloat(el.value)||0:0;
  }

  function num(i){
    var v=parseFloat(String(i.value).replace(',','.'));
    return Number.isFinite(v)&&v>0?v:null;
  }

  function esFuera(){
    if(getVal('vdw-weight')>35)return true;
    if(getVal('vdw-chest')>83)return true;
    if(getVal('vdw-neck')>54)return true;
    if(getVal('vdw-back')>64)return true;
    return false;
  }

  function mostrarFuera(){
    if(!fuera)return;
    result.style.display='none';
    result.classList.remove('is-visible');
    fuera.setAttribute('style','display:block!important;margin-top:12px;border-radius:8px;overflow:hidden;');
  }

  function ocultarFuera(){
    if(!fuera)return;
    fuera.setAttribute('style','display:none!important;margin-top:12px;border-radius:8px;overflow:hidden;');
  }

  function idxFor(v,k){
    if(v===null)return null;
    for(var i=0;i<sizes.length;i++){if(v<=sizes[i][k][1])return i;}
    return sizes.length-1;
  }

  function collect(){return{p:num(F.p),c:num(F.c),l:num(F.l),kg:num(F.kg)};}

  function rec(vals){
    var ph=[{key:'p',value:vals.p},{key:'c',value:vals.c},{key:'l',value:vals.l}].filter(function(i){return i.value!==null;});
    var wi=idxFor(vals.kg,'kg');
    var pk=ph.map(function(i){return{key:i.key,value:i.value,index:idxFor(i.value,i.key)};});
    if(!pk.length&&wi!==null)pk.push({key:'kg',value:vals.kg,index:wi});
    if(!pk.length)return null;
    var mx=pk.reduce(function(m,i){return Math.max(m,i.index);},0);
    var mn=pk.reduce(function(m,i){return Math.min(m,i.index);},mx);
    var ws=[],ft='Dentro de rango';
    pk.forEach(function(i){var r=sizes[i.index][i.key];if(r&&i.value<r[0])ft='Entre tallas: elegimos la mayor';});
    if(mx-mn>=2){ws.push('Medidas apuntan a tallas distintas. Confirma por WhatsApp.');ft='Confirmar';}
    var ct=ph.length>=3?'Alta confianza · 3 medidas':ph.length===2?'Buena confianza · 2 medidas':ph.length===1?'Agrega más medidas':'Referencia por peso';
    return{size:sizes[mx],confidence:ct,fit:ft,warns:ws};
  }

  function reset(){
    result.classList.remove('is-visible');
    result.style.display='none';
    ocultarFuera();
  }

  function markFilled(){Object.keys(F).forEach(function(k){F[k].classList.toggle('is-filled',num(F[k])!==null);});}

  Object.keys(F).forEach(function(k){
    F[k].addEventListener('input',function(){
      markFilled();
      if(esFuera()){
        live.textContent='⚠️ Medidas fuera de rango — haz clic en Calcular talla';
        live.classList.add('is-visible');
        return;
      }
      var r=rec(collect());
      if(!r){live.classList.remove('is-visible');return;}
      live.textContent='→ Talla sugerida: '+r.size.t+' · '+r.confidence;
      live.classList.add('is-visible');
    });
  });

  document.getElementById('vdw-form').addEventListener('submit',function(e){
    e.preventDefault();
    e.stopPropagation();
    reset();
    var vals=collect();
    if(!vals.p&&!vals.c&&!vals.l&&!vals.kg){
      live.textContent='Ingresa al menos la medida de pecho.';
      live.classList.add('is-visible');
      return;
    }
    if(esFuera()){
      live.classList.remove('is-visible');
      mostrarFuera();
      return;
    }
    var r=rec(vals);
    if(!r){live.textContent='Ingresa al menos la medida de pecho.';live.classList.add('is-visible');return;}
    var s=r.size;
    badge.textContent=s.t;badge.style.background=s.color;badge.style.color=s.text;
    title.textContent='Talla recomendada: '+s.t;
    detail.textContent='Cuello '+s.c[0]+'-'+s.c[1]+' cm · Pecho '+s.p[0]+'-'+s.p[1]+' cm · Largo '+s.l[0]+'-'+s.l[1]+' cm';
    conf.textContent=r.confidence;fit.textContent=r.fit;
    if(r.warns.length){warn.textContent=r.warns.join(' ');warn.classList.add('is-visible');}
    else{warn.textContent='';warn.classList.remove('is-visible');}
    var fv=function(lb,v,u){return v?lb+': '+v+u:'';};
    last=['Hola Vestidogs, quiero confirmar la talla de mi perro antes de comprar.','Talla calculada: '+s.t+'.',fv('Pecho',vals.p,' cm'),fv('Cuello',vals.c,' cm'),fv('Largo',vals.l,' cm'),fv('Peso',vals.kg,' kg')].filter(Boolean).join(' ');
    wa.href='https://wa.me/573042189201?text='+encodeURIComponent(last);
    result.classList.add('is-visible');result.style.display='block';
    live.classList.remove('is-visible');copyState.textContent='';
  });

  document.getElementById('vdw-clear').addEventListener('click',function(){
    Object.keys(F).forEach(function(k){F[k].value='';});
    markFilled();live.classList.remove('is-visible');reset();
  });

  copyBtn.addEventListener('click',function(){
    if(!last){copyState.textContent='Calcula primero.';return;}
    if(navigator.clipboard&&navigator.clipboard.writeText){
      navigator.clipboard.writeText(last).then(function(){copyState.textContent='✓ Copiado';});
    }else{copyState.textContent=last;}
  
  });
});